import { ThemeUICSSObject } from 'theme-ui';
import common from './common';

const datagrid: ThemeUICSSObject = {
  ...common('components.paginationDatagrid'),
};

export default datagrid;
